exports.omitMiddleText = (str, length) => {
    if(str.length <= length) {
      return str;
    }
    const start = str.substring(0, length / 2);
    const end = str.substring(str.length - length / 2, str.length);
    return `${start}...${end}`;
}